enum CognitoMfaChallengeStep {
    CONFIRM_SIGN_IN_WITH_SMS_CODE = 'CONFIRM_SIGN_IN_WITH_SMS_CODE',
    CONFIRM_SIGN_IN_WITH_TOTP_CODE = 'CONFIRM_SIGN_IN_WITH_TOTP_CODE',
    CONTINUE_SIGN_IN_WITH_MFA_SELECTION = 'CONTINUE_SIGN_IN_WITH_MFA_SELECTION',
}

interface PendingMfaChallengeState {
    readonly emailAddress: string;
    readonly mfaChallengeStep: CognitoMfaChallengeStep;
    readonly primaryWorkyCorpId: string | null;
}

export type { PendingMfaChallengeState };
export { CognitoMfaChallengeStep };
